import React, { useContext, useEffect, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import "./Buildings.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLandmark, faBuilding, faUser, faTimes } from '@fortawesome/free-solid-svg-icons'
import { listBuilding, removeBuilding } from '../Network/Administration'
import { Loading } from '../Library'
import { NotifyContext } from '../Library/Notify'
import { LanguageContext } from '../Language/LanguageContext'
import { baseURL } from '../Network/Config'
import dayjs from 'dayjs'
import { AlertModalContext } from '../Library/AlertModalContext'

function Buildings() {
    const alertModal = useContext(AlertModalContext)
    const notify = useContext(NotifyContext)
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.administration
    const [isLoading, setLoading] = useState(false)
    const [listBuildings, setListBuilding] = useState([])
    const [searchKeyword, setSearchKeyword] = useState("")
    const [isSearching, setSearching] = useState(false)
    const [foundBuilding, setFoundBuilding] = useState([])
    const history = useHistory()

    const fetchBuilding = () =>{
        setLoading(true)
        listBuilding(
            (data)=>{
                setListBuilding(data)
                setLoading(false)
            },
            (error)=>{
                notify.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            }
        )
    }

    const onSearchBuilding = (e) =>{
        let val = e.target.value.toLowerCase()
        setSearchKeyword(e.target.value)
        if(val.length > 0){
            setSearching(true)
            var result = listBuildings.filter((el)=>el.buildingName.toLowerCase().includes(val))
            setFoundBuilding(result)
        }else{
            setSearching(false)
        }
    }

    const onDeleteBuilding = (buildingId) =>{
        alertModal.setTitle(lang.delete_building)
        alertModal.setDescription(lang.sure_to_delete)
        alertModal.setAlertType("EXTREME")
        alertModal.setButton([
            {
                title: langCx.lang.confirm.ok,
                variant: "danger",
                onClick: ()=>{ 
                    alertModal.setIsShow(false)
                    setLoading(true)
                    removeBuilding(buildingId,
                        ()=>{
                            fetchBuilding()
                            notify.showNotify(lang.deleted_building, lang.deleted_building_desc, 0)
                        },
                        (error)=>{
                            notify.showNotify("Something wrong", error.message, 2)
                        })
                }
            },
            {
                title: langCx.lang.confirm.cancel,
                variant: "secondary",
                onClick: ()=>{ 
                    alertModal.setIsShow(false) 
                }
            }
        ])
        alertModal.setIsShow(true)
        // if(window.confirm(lang.sure_to_delete)){
        //     setLoading(true)
        //     removeBuilding(buildingId,
        //         ()=>{
        //             fetchBuilding()
        //             notify.showNotify(lang.deleted_building, lang.deleted_building_desc, 0)
        //         },
        //         (error)=>{
        //             notify.showNotify("Something wrong", error.message, 2)
        //         })
        // }
    }

    useEffect(()=>{
        fetchBuilding()
    },[])

    return (
        <div id="buildings">
            { isLoading ? <Loading/>: null }
            <div className="top-container">
                <div>
                    <Button onClick={()=>history.push("/buildings/create")}>{lang.add_building}</Button>
                </div>
                <div>
                    <Form.Control
                    type="search"
                    placeholder={lang.search_building}
                    value={searchKeyword}
                    onChange={onSearchBuilding}
                    />
                </div>
            </div>
            { isSearching ?
            <div className="search-indicator">
                <b>{foundBuilding.length || 0}</b>{" " + lang.building_search_desc + " "}
                <a href="#"
                onClick={(e)=>{
                    e.preventDefault()
                    setSearchKeyword("")
                    setSearching(false)
                }}>
                    {lang.clear_search}
                </a>
            </div> 
            : null
            }
            <div className="building-container">
                { !isSearching ?
                <>
                { listBuildings.map((item, key) =>
                    <BuildingItem
                    key={key}
                    buildingName={item.buildingName}
                    address={item.address}
                    countUser={item.peopleCount}
                    countCompanies={item.companiesCount}
                    registerDate={item.registerDate}
                    maxUser={item.packages.limitUser}
                    maxCompanies={item.packages.limitTenants}
                    logo={item.buildingLogo}
                    onClickDetail={()=>history.push("/buildings/view/"+item.id)}
                    onClickDelete={()=>onDeleteBuilding(item.id)}
                    />
                )}
                </>
                :
                <>
                { foundBuilding.map((item, key) =>
                    <BuildingItem
                    key={key}
                    buildingName={item.buildingName}
                    address={item.address}
                    countUser={item.peopleCount}
                    countCompanies={item.companiesCount}
                    registerDate={item.registerDate}
                    maxUser={item.packages.limitUser}
                    logo={item.buildingLogo}
                    maxCompanies={item.packages.limitTenants}
                    onClickDetail={()=>history.push("/buildings/view/"+item.id)}
                    onClickDelete={()=>onDeleteBuilding(item.id)}
                    />
                )}
                </>
                }
            </div>
        </div>
    )
}

function BuildingItem({ buildingName, logo, address, countUser, maxUser, countCompanies, maxCompanies, registerDate, onClickDetail, onClickDelete }){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.administration

    return(
        <div className="building-item">
            <div style={{ marginRight: 20 }}>
                <div className="building-logo">
                    { logo !== null ?
                    <img src={baseURL + logo}/>
                    : 
                    <FontAwesomeIcon icon={faLandmark}/>
                    }
                </div>
            </div>
            <div style={{ flex: 2, marginRight: 8 }}>
                <div className="title">{buildingName}</div>
                <div className="desc">{address}</div>
                <div className="desc" style={{ marginTop: 5 }}>{lang.register_date + " : " + dayjs(registerDate).format("D MMMM YYYY")}</div>
            </div>
            <div style={{ flex: 1 }}>
                <FontAwesomeIcon icon={faUser}/>
                <span style={{ marginLeft: 10 }}>{countUser?.toLocaleString() || 0}/{maxUser > 0 ? maxUser?.toLocaleString() : "∞"}</span>
            </div>
            <div style={{ flex: 1 }}>
                <FontAwesomeIcon icon={faBuilding}/>
                <span style={{ marginLeft: 10 }}>{countCompanies?.toLocaleString() || 0}/{maxCompanies > 0 ? maxCompanies?.toLocaleString() : "∞"}</span>
            </div>
            <div style={{ width: 130 }}>
                <Button size="sm" 
                onClick={onClickDetail}
                style={{ marginRight: 8 }}>
                    {lang.detail}
                </Button>
                <Button 
                size="sm" 
                variant="danger"
                onClick={onClickDelete}>
                    <FontAwesomeIcon icon={faTimes}/>
                </Button>
            </div>
        </div>

    )
}

export default Buildings
